import React from 'react'
import { useSelector,connect } from 'react-redux'
import { Redirect,useLocation } from 'react-router-dom';
import authService from "../utils/authUtils";

const AuthGuard = (props) => {
  const location = useLocation()
  const {
    auth: { user },
  } = useSelector((state) => state);
    if (user === null && !authService.isAuthenticated()) {
      
const fullUrl = location.pathname + location.search;
console.log("jhkgshagdhsasdasd",fullUrl)
      localStorage.setItem("redirectUrl",fullUrl)
      return <div>Ok</div>
      // return <Redirect to="/login" />;
    }
   

 
    return props.children;
  

};
const mapStateToProps=(state)=>{
  return {
    user:state.auth.user
  }
}


export default connect(mapStateToProps,{})(AuthGuard);
